/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState } from 'react'
import { ILayout, useLayout } from '../../core'
import { ModalVersion } from './modal/Modalversion'
type ID = undefined | null | number


const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  const [ID, setID] = useState<ID>(undefined)

  return (
    <>
      <div className='f-parrafo text-dark order-2 order-md-1'>
        CTX Controller&nbsp;
        <a
          target='_blank'
          onClick={() => setID(null)}
          className='footer-link text-gray-800 text-hover-info'
        >
          <u>(v.2.3.0)  </u>

        </a>&nbsp;

        <span className=' me-1'>
          {new Date().getFullYear().toString()}
        </span>
        <a
          target='_blank'
          className='footer-link text-gray-800 '
        >
          Cloud Transit Xchange, Inc.&nbsp;
        </a>

      </div>

      {ID !== undefined && <ModalVersion setID={setID} id={ID} />}

    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
